import { render, staticRenderFns } from "./PointMgmt.vue?vue&type=template&id=1bd5a057&scoped=true"
import script from "./PointMgmt.vue?vue&type=script&lang=js"
export * from "./PointMgmt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd5a057",
  null
  
)

export default component.exports